module.exports = __webpack_public_path__ + "img/bc-hasilat.1733a6a6.png";